import Banner from "../ui/home/Banner";
import { CampaignsList } from "../features/campaign/components/organism/CampaignsList";
import { ScrollTriggeredVideo } from "../ui/about/organisms/ScrollTriggeredVideo";
import { HorizontalScrollCarousel } from "../ui/organisms/HorizontalScrollCarousel";

const Home = () => {

    return (
        <>
            <Banner/>
            <CampaignsList />
            <ScrollTriggeredVideo />
            <HorizontalScrollCarousel/>
        </>
    );
};

export default Home;

